/*
 * Copyright(C) 2018, xplo.re IT Services, Michael Maier.
 * All rights reserved.
 */

(function () {
    "use strict";

    // Initialise common plugins.
    $(document).ready(function () {
        var components = $.HSCore.components;

        // Configure jQuery UI widget language.
        var datePickerConfig = $.datepicker.regional.de;

        $.datepicker.setDefaults(datePickerConfig);

        components.HSCarousel.init(".js-carousel");
        components.HSTabs.init("[role='tablist']");
        components.HSGoTo.init(".js-go-to");
        components.HSPopup.init(".js-fancybox");
        components.HSCountQty.init(".js-quantity");
        components.HSSelect.init(".js-custom-select");

        // HS datepicker overwrites jQuery UI configuration, re-supply settings.
        components.HSDatepicker.init(".js-datepicker", {
            dateFormat: datePickerConfig.dateFormat,
            dayNamesMin: datePickerConfig.dayNamesMin
        });

        // Masonry.
        $(".masonry-grid").imagesLoaded().then(function () {
            $(".masonry-grid").masonry({
                columnWidth: ".masonry-grid-sizer",
                itemSelector: ".masonry-grid-item",
                percentPosition: true
            });
        });
    });

    $(window).on("load", function () {
        var components = $.HSCore.components;

        // Page header.
        components.HSHeader.init($("#js-header"));
        $.HSCore.helpers.HSHamburgers.init(".hamburger");

        // Mega menu.
        $(".js-mega-menu").HSMegaMenu({
            event: "hover",
            pageContainer: $(".container"),
            breakpoint: 991
        });

        // Cube portfolio.
        components.HSCubeportfolio.init(".cbp");

    });

    $(window).on("resize", function () {
        setTimeout(function () {
            $.HSCore.components.HSTabs.init("[role='tablist']");
        }, 200);
    });
}());